/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import { Divider, Steps, Row, Col, message, Spin } from "antd";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router";

import urls from "../../../api/urls";
// import "./style.scss";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import { useParams } from "react-router";
import NewRateCard from "../../LeadGenerationCP/NewRateCard";
import CompanyRateCard from "../../CpOnboardingNew/CompanyRateCard";

import AggreementDetails from "./agreementDetails";
import DocumentDetails from "../../LeadGenerationCP/DocumentDetails";
import { customerOnboardingAPI } from "../../../api/LeadApi";
import AgreementUpload from "../../LeadGenerationCP/AgreementUpload";
import BusinessDetails from "../../LeadGenerationClient/LeadGenClientSteps/LeadClientOnboardingSteps/BusinessDetails";
import OrganisationDetails from "../../LeadGenerationClient/LeadGenClientSteps/LeadClientOnboardingSteps/OrganizationDetails";

const { UPDATE_LEAD_CLIENT_DETAILS, GET_CLIENT_LEAD_ID } = urls;

export const Onboarding = () => {
  const param = useParams();
  const [current, setCurrent] = useState(0);
  const [sideStepHide, setSideStepHide] = useState(false);
  const [getData, setGetData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cpPinCode, setCpPinCode] = useState(null);
  const history = useLocation();

  useEffect(() => {
    if (history?.state?.step) {
      console.log(history?.state?.step);

      setCurrent(history?.state?.step);
    }
  }, [history?.state]);
  useEffect(() => {
    let clientId = localStorage.getItem("clientLeadId");
    if (clientId || param?.id) {
      if (current !== 2) {
        getClientDetails(clientId || param?.id);
      }
    }
    window.scrollTo(0, 0);
  }, [current]);

  // const getClientDetails = async (clientId) => {
  //   let response = await API.Api(
  //     GET_CLIENT_LEAD_ID + `${clientId}`
  //   ).getWithPremiseHeader();

  //   if (response.status) {
  //     let data = response?.response?.data;
  //     setGetData(data);
  //   } else {
  //     message.error(response?.response?.data?.message || "Network error");
  //   }
  // };

  const getClientDetails = async (id) => {
    const response = await customerOnboardingAPI.getLeadById(id);
    if (response?.status) {
      let data = response?.response?.data;
      setGetData(data);
    } else {
      message.error("Network error");
    }
  };

  const patchClient = async (values) => {
    setLoading(true);
    let clientLeadId = localStorage.getItem("clientLeadId");
    // let response = await API.Api(
    //   UPDATE_LEAD_CLIENT_DETAILS + `${clientLeadId}`
    // ).patchCustomHeader(values, {
    //   "SMCS-PREMISE-ID": userId?.userInfo?.premiseId,
    // });
    let response = await customerOnboardingAPI.patchLead(clientLeadId, values);
    if (response?.status) {
      setLoading(false);
      message.success("Data added successfully.");
      setCurrent(current + 1);
    } else {
      setLoading(false);
    }
  };

  const onChange = (value) => {
    setCurrent(value);
  };

  const handleStepsChange = () => {
    setCurrent(current + 1);
  };

  const goBackStep = () => {
    window.scrollTo(0, 0);
    setCurrent(current - 1);
  };

  const stepsItems = [
    {
      title: "Organisation Details",
      description: "Please provide your org details",
    },
    {
      title: "Quotation",
      description: "Quotation Provide rate card details",
      //   disabled: !getData?.orgName,
    },
    {
      title: "Agreement Details",
      description: "Please Agree to all t & c",
      //   disabled: !(getData?.quotations?.length > 0),
    },
    {
      title: "Business Details",
      description: "Please provide your business details",
      //   disabled: !(getData?.quotations?.length > 0),
    },
    {
      title: "Document Upload",
      description: "Please upload your document",
      //   disabled: !(getData?.quotations?.length > 0),
    },
  ];
  if (getData?.status?.toLowerCase() === "approved") {
    stepsItems.push({
      title: "Agreement Upload",
      description: "Please upload your document",
      disabled: !(getData?.quotations?.length > 0),
    });
  }
  return (
    <div className="master-main-container">
      <Spin
        spinning={loading}
        indicator={
          <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
        }
      >
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          className="steps-container "
        >
          <Steps
            current={current}
            direction="horizontal"
            onChange={onChange}
            items={stepsItems}
          />
        </Col>

        <Row
          className={sideStepHide ? "" : "p-1"}
          style={{ height: "70vh", overflow: "scroll" }}
        >
          <Col xs={24} sm={24} md={24} lg={24} xl={sideStepHide ? 24 : 24}>
            {current === 0 ? (
              <OrganisationDetails
                handleStepsChange={handleStepsChange}
                patchClient={patchClient}
                getData={getData}
                goBackStep={goBackStep}
              />
            ) : current === 1 ? (
              <CompanyRateCard
                handleStepsChange={handleStepsChange}
                //getData={companyData}
                goBackStep={goBackStep}
                // userType={"COMPANY"}
                // companyId={}
              />
            ) : //profile

            current === 2 ? (
              <AggreementDetails
                handleStepsChange={handleStepsChange}
                goBackStep={goBackStep}
                getData={getData}
                userType={"CLIENT"}
                goToStep={(step) => setCurrent(step)}
              />
            ) : current === 3 ? (
              <BusinessDetails
                handleStepsChange={handleStepsChange}
                goBackStep={goBackStep}
                getData={getData}
                userType={"CLIENT"}
                patchClient={patchClient}
                goToStep={(step) => setCurrent(step)}
              />
            ) : current === 4 ? (
              <DocumentDetails
                handleStepsChange={handleStepsChange}
                goBackStep={goBackStep}
                getData={getData}
                userType={"CLIENT"}
                goToStep={(step) => setCurrent(step)}
              />
            ) : current === 5 &&
              getData?.status?.toUpperCase() === "APPROVED" ? (
              <AgreementUpload
                handleStepsChange={handleStepsChange}
                goBackStep={goBackStep}
                getData={getData}
                userType={"CLIENT"}
                goToStep={(step) => setCurrent(step)}
                btnName={"Send For Approval"}
              />
            ) : (
              ""
            )}
          </Col>
        </Row>
      </Spin>
    </div>
  );
};

export default Onboarding;
